import { JuloUpdateEntry } from "./types"

export const namedInspectionOrdersEntry: JuloUpdateEntry = {
  slug: "2026-09-26-named-inspection-orders",
  date: "2026-09-26",
  title: "Flera egna ordningar i besiktningen",
  description:
    'Under [Ordning för besiktning](/settings/inspection-order) kan ni nu skapa flera ordningar och döpa dem till vad ni vill, till exempel en för vårservice och en för vinterservice. Er nuvarande ordning finns kvar under namnet "Egen ordning".\n\nI varje ordning kan ni dölja komponenter med ögat till höger. En dold komponent visas inte i besiktningen när ordningen är vald, men ni kan alltid lägga till den genom att söka efter den. Ändringar sparas automatiskt, precis som i prislistan.\n\nI besiktningen väljer ni ordning i samma lista som L-check och Komponentgrupp. Med L-check och Komponentgrupp visas fortfarande alla komponenter.',
  images: [
    {
      src: "/julo-updates/2026-09-26-named-inspection-orders/1-ordningar.png",
      alt: 'Inställningssidan "Ordning för besiktningsdelar" med ordningen "Egen ordning" vald och knappar för att skapa, byta namn på och ta bort en ordning. Komponenten Dynamo är gråmarkerad med texten "Dold" och ett överstruket öga, medan Styre och styrstam, Framlampa, Ringklocka och Display visas med sina nummer och ett öppet öga.',
    },
  ],
}
